/**
 * Theme Territoriale - Scripts
 * File: scripts.js
 * Description: file Js principale para el tema Territoriale qui vengono inizializzati i moduli js.
 *
 */

import StickyNavbar from "./modules/sticky-navbar.js";
import { initAccordionScroll } from "./modules/accordion-scroll.js";
import { initGallerySlider } from "./modules/gallery-slider.js";
import { initPrimoPianoSlider } from "./modules/primo-piano-slider.js";
import { initBannerConsigliamoSlider } from "./modules/banner-consigliamo.js";
import { initPartnerSlider } from "./modules/partner-slider.js";
import { initAuthRegister } from "./modules/auth-register.js";

jQuery(document).ready(function ($) {
  console.log("Theme Territoriale → DOM pronto 👍");

  // Inizializza la Navbar sticky
  StickyNavbar.initialize("mainNavbar");

  // Initializza animazione Accordion scroll, attivato solo se necessario
  initAccordionScroll();

  // Inizializza lo slider PrimoPiano, attivato solo se necessario
  initPrimoPianoSlider();

  // Inizializza lo slider Banner Consigliamo, attivato solo se necessario
  initBannerConsigliamoSlider();

  // Inizializza lo gallery slider, attivato solo se necessario
  initGallerySlider();

  // Inizializza lo slider Partner, attivato solo se necessario
  // A partire della versione Theme Territoriale 1.1.0
  initPartnerSlider();

  // Inizializza la validazione registrazione (tooltip e forza password)
  initAuthRegister();
});

/**
 * INFO: Swiper e GLightbox sono inizializzati correttamente anche se i loro script
 * vengono inclusi nel DOM *dopo* questo file (scripts.js), grazie a:
 *
 * 1. jQuery(document).ready() → posticipa l'esecuzione finché il DOM è pronto.
 * 2. Gli script Swiper/GLightbox sono caricati *sincronicamente* subito dopo,
 *    quindi disponibili al momento della chiamata a initGallerySlider().
 *
 * ⚠️ Attenzione:
 * Se in futuro gli script vengono caricati in modalità async/defer, da plugin,
 * o caricati più tardi nel DOM, potrebbero non essere ancora disponibili.
 *
 * Soluzioni alternative in tal caso:
 * - Usare un polling (es. setInterval) che aspetta Swiper e GLightbox.
 * - Separare l’inizializzazione in un evento custom o callback.
 */
